module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "manualConciliationWrapper"
    }
  }, [(_vm.shown.occurrenceReason) ? _c('multi-select-modal', {
    attrs: {
      "id": "occurrenceReasonModal",
      "data": _vm.data.occurrenceReason
    },
    on: {
      "close-modal": _vm.closeModal
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('relatorioOcorrencia.titulos.titulo'),
      "subTitle": _vm.$t('relatorioOcorrencia.titulos.subtitulo')
    }
  }), _c('filter-portlet', {
    attrs: {
      "portletTitle": _vm.$t('relatorioOcorrencia.titulos.filtro')
    }
  }, [_c('form-search', {
    attrs: {
      "slot": "filters",
      "fn": _vm.validate,
      "isDisabled": _vm.disableSearchButton,
      "showLoadingFullPage": false,
      "hasExportFile": false
    },
    slot: "filters"
  }, [_c('div', {
    staticClass: "row-filter-small"
  }, [_c('date-range', {
    ref: "dateRange",
    attrs: {
      "initialFromDate": _vm.firstDate,
      "initialToDate": _vm.finalDate,
      "maxRange": 200
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _c('div', {
    staticClass: "row row-filter-small"
  }), _c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11"
  }, [_c('toggle-button', {
    staticClass: "pull-left",
    attrs: {
      "value": true,
      "color": {
        "checked": "#40b9bb",
        "unchecked": "#E5E5E5"
      },
      "height": 20,
      "width": 40
    },
    on: {
      "change": _vm.resetFilter
    },
    model: {
      value: (_vm.isAdvancedSearch),
      callback: function($$v) {
        _vm.isAdvancedSearch = $$v
      },
      expression: "isAdvancedSearch"
    }
  }), _c('label', {
    staticClass: "control-label pull-left label-export",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioConciliacao.labels.pesquisaAvancada'))
    }
  })], 1)]), (_vm.isAdvancedSearch) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row row-filter-medium"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "occurrenceSelected"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('relatorioOcorrencia.labels.motivoOcorrencia'))
    }
  })]), _c('div', {
    staticClass: "col-md-6 col-sm-8 col-xs-11 px-0"
  }, [_c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('better-input-tag', {
    attrs: {
      "tags": _vm.data.occurrenceReason.selectedItems,
      "read-only": false,
      "typeable": false,
      "defaultTagsIfEmpty": _vm.defaultTags.occurrenceReason,
      "props": _vm.inputTagsProps.occurrenceReason
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.data.occurrenceReason, "selectedItems", $event)
      }
    }
  })], 1), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [_c('button-primary', {
    staticClass: "filterButton filter-input-tag",
    attrs: {
      "title": _vm.$t('relatorioOcorrencia.labels.selecaoMotivoOcorrencia'),
      "faIcon": "fa fa-search",
      "id": "btnSelecionarMotivosDeOcorrencia-Ocorrencias",
      "clickFunction": _vm.openSelectOccurrencesModal
    }
  })], 1)])]), _c('input-establishment', {
    attrs: {
      "id": "establishmentsFilterOccurrenceReport",
      "urls": _vm.establishimentsUrls,
      "selectedItems": _vm.selectedEstablishments
    },
    on: {
      "update:selectedItems": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:selected-items": function($event) {
        _vm.selectedEstablishments = $event
      },
      "update:establishments": function($event) {
        _vm.selectedEstablishments = $event
      }
    }
  })], 1) : _vm._e()])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTreegrid),
      expression: "showTreegrid"
    }]
  }, [_c('tree-grid', {
    attrs: {
      "gridId": "occurrenceReportGrid",
      "result": _vm.result,
      "exportUrl": _vm.exportUrl,
      "treeGridFileName": "RelatorioOcorrencia",
      "cfgObj": _vm.treeGridCfg
    }
  })], 1)], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-475e994c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-475e994c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/reports/occurrenceReport/occurrenceReport.pug
// module id = 1410
// module chunks = 0